import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject, input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { applyFilterNavigationHandler } from 'dias-core/utils/category/filter-navigation-utils';
import { Observable, Subject } from 'rxjs';

import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { FilterNavigation } from 'ish-core/models/filter-navigation/filter-navigation.model';
import { URLFormParams } from 'ish-core/utils/url-form-params';
import { FilterNavigationBadgesComponent } from 'ish-shared/components/filter/filter-navigation-badges/filter-navigation-badges.component';
import { FilterNavigationHorizontalComponent } from 'ish-shared/components/filter/filter-navigation-horizontal/filter-navigation-horizontal.component';
import { FilterNavigationSidebarComponent } from 'ish-shared/components/filter/filter-navigation-sidebar/filter-navigation-sidebar.component';

@Component({
  selector: 'custom-filter-navigation',
  templateUrl: './custom-filter-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FilterNavigationSidebarComponent,
    FilterNavigationHorizontalComponent,
    FilterNavigationBadgesComponent,
    AsyncPipe,
  ],
})
export class CustomFilterNavigationComponent implements OnInit, OnDestroy {
  private shoppingFacade = inject(ShoppingFacade);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  readonly fragmentOnRouting = input<string>(undefined);
  readonly orientation = input<'sidebar' | 'horizontal'>('sidebar');
  readonly showCategoryFilter = input(true);

  filter$: Observable<FilterNavigation>;
  private destroy$ = new Subject<void>();

  ngOnInit() {
    this.filter$ = this.shoppingFacade.currentFilter$(this.showCategoryFilter());
  }

  applyFilter(event: { searchParameter: URLFormParams }) {
    applyFilterNavigationHandler(event, this.router, this.activatedRoute);
  }

  get isSideBar() {
    return this.orientation() === 'sidebar';
  }

  clearFilters() {
    this.router.navigate([], {
      queryParamsHandling: 'merge',
      relativeTo: this.activatedRoute,
      queryParams: { filters: undefined, page: 1 },
      fragment: this.fragmentOnRouting(),
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
